import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
var _instance = /*#__PURE__*/_classPrivateFieldLooseKey("instance");
export class AudienceFilter {
  constructor(initial = {}) {
    Object.defineProperty(this, _instance, {
      writable: true,
      value: void 0
    });
    this.byTag = tag => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].tags.add(tag);
      return this;
    };
    this.byApplication = ({
      name
    }) => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].apps.add(name);
      return this;
    };
    this.sameWindow = (targetOnlySameWindow = true) => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].sameWindow = targetOnlySameWindow;
      return this;
    };
    this.excludeSelf = (excludeSelfFromRecipients = true) => {
      _classPrivateFieldLooseBase(this, _instance)[_instance].excludeSelf = excludeSelfFromRecipients;
      return this;
    };
    this.build = () => _classPrivateFieldLooseBase(this, _instance)[_instance];
    this.isTargetAudience = context => {
      const {
        client,
        message,
        subscriberClientId
      } = context;
      return AudienceFilter.isTargetAudience(_classPrivateFieldLooseBase(this, _instance)[_instance], client, message, subscriberClientId);
    };
    _classPrivateFieldLooseBase(this, _instance)[_instance] = Object.assign({
      tags: new Set(),
      apps: new Set(),
      excludeSelf: false,
      sameWindow: false
    }, initial);
  }
  static builder() {
    return new AudienceFilter();
  }
  static from(instance) {
    return new AudienceFilter(instance);
  }
}
AudienceFilter.isTargetAudience = (audience, {
  appName,
  tags: clientTags,
  portalId
}, {
  senderPortalId,
  sender
}, subscriberClientId) => {
  const {
    apps,
    tags,
    excludeSelf,
    sameWindow
  } = audience;
  if (apps.size > 0 && !apps.has(appName)) {
    return false;
  }
  if (tags.size > 0 && !Array.from(tags).some(tag => clientTags.includes(tag))) {
    return false;
  }
  if (excludeSelf && sender === subscriberClientId) {
    return false;
  }
  if (sameWindow && portalId && senderPortalId === portalId) {
    return false;
  }
  return true;
};